import React from 'react'
import { Link } from 'react-router-dom';

const Reseller = () => {
    const [merchantId, setMerchantId] = React.useState("");
    const [merchantIdError, setMerchantIdError] = React.useState("");
    const [showSuccess, setShowSuccess] = React.useState(false);

    const validateMerchantId = () => {
      if (!merchantId.trim()) {
        setMerchantIdError("Merchant ID is required.");
        return false;
      }

      setMerchantIdError("");
      return true;
    };

    return (
        <main className="main-content">
            {/* Success Message Popup */}
            {showSuccess && (
              <div className="fixed top-4 right-4 z-50">
                <div className="bg-[#635BFF] text-white px-4 py-2 rounded-lg shadow-lg flex items-center">
                  <span className="material-symbols-outlined mr-2">check_circle</span>
                  Merchant mapped successfully!
                </div>
              </div>
            )}

            <div>
                {/* Main Content */}
                <div class="mb-6 flex flex-wrap items-center justify-between ml-4">
                    <h2 class="text-xl font-semibold">
                        Resellers
                    </h2>

                    <nav>
                        <ol class="flex items-center gap-1.5 mr-7">
                            <li>
                            <Link
                class="inline-flex items-center gap-1.5 text-sm text-black "
                to="/dashboard"
              >
                Home /
              </Link>
                            </li>
                            <li class="text-sm text-gray-800 ">
                                Resellers
                            </li>
                        </ol>
                    </nav>
                </div>

                <div class="mx-auto p-4 md:p-4">
                    <div class="space-y-5 sm:space-y-6">
                        <div class="rounded-2xl border border-gray-200 bg-white ">
                            <div class="px-5 py-4 sm:px-6 sm:py-5">
                                <h3 class="text-base font-medium text-gray-800 ">
                                </h3>
                            </div>
                            <div class="p-5 border-t border-gray-100  sm:p-6">
                                <div
                                    class="overflow-hidden rounded-xl border border-gray-200 bg-white"
                                >
                                    <div class="max-w-full overflow-x-auto">
                                        <table class="min-w-full">
                                            <thead>
                                                <tr className="text-white border-b border-gray-100  whitespace-nowrap" style={{ backgroundColor: '#635BFF' }}>
                                                    <th class="px-5 py-3 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p
                                                                class="font-medium text-white text-sm"
                                                            >
                                                                SI.No
                                                            </p>
                                                        </div>
                                                    </th>
                                                    <th class="px-5 py-3 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p
                                                                class="font-medium text-white text-sm "
                                                            >
                                                                Partner ID
                                                            </p>
                                                        </div>
                                                    </th>
                                                    <th class="px-5 py-3 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p
                                                                class="font-medium text-white text-sm "
                                                            >
                                                                Name
                                                            </p>
                                                        </div>
                                                    </th>
                                                    <th class="px-5 py-3 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p
                                                                class="font-medium text-white text-sm "
                                                            >
                                                                Email
                                                            </p>
                                                        </div>
                                                    </th>
                                                    <th class="px-5 py-3 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p
                                                                class="font-medium text-white text-sm "
                                                            >
                                                                Created At
                                                            </p>
                                                        </div>
                                                    </th>
                                                    <th class="px-5 py-3 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p
                                                                class="font-medium text-white text-sm "
                                                            >
                                                                Map Merchant
                                                            </p>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
                                                <tr class="whitespace-nowrap">
                                                    <td class="px-5 py-4 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p class="text-black text-sm ">
                                                                1
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td class="px-5 py-4 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p class="text-black text-sm ">
                                                                BN123DD
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td class="px-5 py-4 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p class="text-black text-sm ">Anderson</p>
                                                        </div>
                                                    </td>
                                                    <td class="px-5 py-4 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p class="text-black text-sm ">Anderson@gmail.com</p>
                                                        </div>
                                                    </td>
                                                    <td class="px-5 py-4 sm:px-6">
                                                        <div class="flex items-center">
                                                            <p class="text-black text-sm ">26 Jul, 2024, 6:53 19</p>
                                                        </div>
                                                    </td>
                                                    <td class="px-5 py-4 sm:px-6">
                                                        <div>
                                                            <input 
                                                                type="text" 
                                                                placeholder="Enter Merchant ID" 
                                                                className={`border rounded-lg p-2 mb-2 w-full focus:outline-none focus:ring-2 ${
                                                                    merchantIdError ? 'border-red-500 focus:ring-red-500' : 'focus:ring-[#635BFF]'
                                                                }`}
                                                                value={merchantId}
                                                                onChange={(e) => setMerchantId(e.target.value)}
                                                                onBlur={validateMerchantId}
                                                            />
                                                            {merchantIdError && (
                                                                <p className="text-red-500 text-xs mt-1">{merchantIdError}</p>
                                                            )}
                                                        </div>
                                                        <button 
                                                            className="bg-[#635BFF] mt-2 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-[#4a28aa] transition w-full"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (validateMerchantId()) {
                                                                    setShowSuccess(true);
                                                                    setTimeout(() => setShowSuccess(false), 5000);
                                                                    setMerchantId("");
                                                                }
                                                            }}
                                                        >
                                                            Add Mapping
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Reseller;